import React from "react";

import "./style.css";

const SmoothTimeLine = ({ data }) => (
  <section id="work-history">
    {/* <div class="user-details">
      <h1> Work History </h1>
    </div> */}
    <div className="work">
      <ul className="timeline">
        {data &&
          data.map((item) => (
            <li className="timeline-event" key={item.key}>
              <label className="timeline-event-icon"></label>
              <div className="timeline-event-copy">
                <p className="timeline-event-thumbnail">{item.date}</p>
                <h3>{item.company}</h3>
                <h4>{item.role}</h4>
                <span>{item.description}</span>
                <p>
                <ul style={{listStyle:"outside",fontSize:"14px"}}>
                  {item.points && item.points.map((point) => <li>{point}</li>)}
                </ul>
                </p>
              </div>
            </li>
          ))}
      </ul>
    </div>
  </section>
);

export default SmoothTimeLine;
